<template>
    <spinner-until :condition="!showSpinner">
        <div class="survey-note-list">

            <!-- latest notes -->
            <div v-if="latestNotes.length">
                <div v-for="(note, i) in latestNotes" :key="i">
                    <survey-note-list-item :survey-note="note"></survey-note-list-item>
                </div>
            </div>
            <div v-else>
                {{ $i18n.gt('LABEL_NO_PROGRESS_NOTES') }}
            </div>

            <!-- previous notes -->
            <div v-if="!forPatient && olderNotes.length">

                <div class="toggle-button-container clearfix mb-3">
                    <b-btn v-b-toggle.collapseNotes variant="secondary">
                        {{ $i18n.gt('LABEL_OLDER_NOTES') }}
                        <shs-icon name="caret-bottom"></shs-icon>
                    </b-btn>
                </div>

                <b-collapse id="collapseNotes">
                    <div v-for="(note, i) in olderNotes" :key="i">
                        <survey-note-list-item :survey-note="note"></survey-note-list-item>
                    </div>
                </b-collapse>

            </div>
        </div>
    </spinner-until>
</template>

<script>
import * as _ from 'lodash'
import SurveyNote from "@/providers/SurveyNote"

/**
 * Displays a list of previous SurveyNotes for a given patient
 */
export default {
    name: 'SurveyNoteList',
    props: {
        forPatient: Boolean
    },
    computed: {
        participant () {
            return this.$store.state.patientParticipant
        },
        showSpinner() {
            return !this.participant.surveyNotes
        },
        latestNotes() {
            if (this.forPatient) {
                const note = _.find(this.participant.surveyNotes, (sn, i) => SurveyNote.isLocked(sn))
                if (note) {
                    return [note]
                } else {
                    return []
                }
            } else {
                return _.filter(this.participant.surveyNotes, (sn, i) => {
                    return this.isLatestNote(sn, i)
                })
            }
        },
        olderNotes() {
            return _.filter(this.participant.surveyNotes, (sn, i) => {
                return !this.isLatestNote(sn, i)
            })
        },
    },
    methods: {
        isLatestNote(note, i) {
            return i == 0 || SurveyNote.isDraft(note) || SurveyNote.hasNoBill(note)
        }
    }
}
</script>
